// Avatar "Create your own" akışı için rastgele kimlik havuzu.
// Kullanıcı isterse üzerine yazar; boşsa buradan gender'a göre rastgele isim +
// title ön-doldurulur, "shuffle" ile yeniden atanır.
//
// ÖNEMLİ: Math.random YALNIZCA randomAvatarIdentity() içinde çağrılır — modül
// tepesinde veya bir useState initializer'ında ASLA (deterministik import + SSR/
// resume güvenliği için). İsimler Türkçe + uluslararası karışık, gender'a göre.

export const MALE_NAMES = [
  // Türkçe
  "Kemal",
  "Mehmet",
  "Ahmet",
  "Mustafa",
  "Ali",
  "Hasan",
  "Hüseyin",
  "İbrahim",
  "Emre",
  "Burak",
  "Cem",
  "Barış",
  "Serkan",
  "Tolga",
  "Onur",
  "Volkan",
  "Kaan",
  "Arda",
  "Efe",
  "Mert",
  "Selim",
  "Umut",
  "Yusuf",
  "Furkan",
  "Berk",
  "Sinan",
  "Tarık",
  "Levent",
  "Okan",
  "Doruk",
  "Ozan",
  "Kerem",
  "Bora",
  "Çağan",
  "Alp",
  // Uluslararası
  "David",
  "James",
  "Michael",
  "John",
  "Robert",
  "Daniel",
  "Thomas",
  "Alexander",
  "Lucas",
  "Liam",
  "Noah",
  "Ethan",
  "Mason",
  "Benjamin",
  "Henry",
  "Oliver",
  "William",
  "Samuel",
  "Adam",
  "Marco",
  "Leon",
  "Felix",
  "Diego",
  "Carlos",
  "Pablo",
  "Hugo",
  "Andrei",
  "Ivan",
  "Nikolai",
  "Omar",
  "Karim",
  "Youssef",
  "Hiroshi",
  "Kenji",
  "Wei",
  "Raj",
  "Arjun",
  "Mateo",
  "Santiago",
  "Luca",
  "Erik",
  "Anders",
  "Sven",
];

export const FEMALE_NAMES = [
  // Türkçe
  "Ayşe",
  "Fatma",
  "Zeynep",
  "Emine",
  "Elif",
  "Merve",
  "Büşra",
  "Esra",
  "Selin",
  "Ece",
  "Gizem",
  "Melis",
  "Sıla",
  "Yasemin",
  "Derya",
  "Aslı",
  "Pınar",
  "Cansu",
  "Damla",
  "İrem",
  "Ceren",
  "Gül",
  "Nur",
  "Sena",
  "Beren",
  "Duru",
  "Naz",
  "Ela",
  "Defne",
  "Dilara",
  "Berrak",
  "Eda",
  "Sude",
  "Nehir",
  "Melike",
  // Uluslararası
  "Maria",
  "Sofia",
  "Emma",
  "Olivia",
  "Ava",
  "Isabella",
  "Mia",
  "Charlotte",
  "Amelia",
  "Emily",
  "Grace",
  "Chloe",
  "Anna",
  "Elena",
  "Julia",
  "Laura",
  "Sara",
  "Nina",
  "Lucia",
  "Carmen",
  "Aisha",
  "Fatima",
  "Leila",
  "Yuki",
  "Sakura",
  "Mei",
  "Priya",
  "Ananya",
  "Ingrid",
  "Astrid",
  "Freya",
  "Clara",
  "Alice",
  "Victoria",
  "Natalie",
];

export const ROLE_TITLES = [
  "Eğitmen",
  "Uzman",
  "Koç",
  "Danışman",
  "Sunucu",
  "Anlatıcı",
  "Mentor",
  "Öğretmen",
  "Analist",
  "Rehber",
  "Eğitim Uzmanı",
  "Uzman Eğitmen",
  "Akademisyen",
  "Moderatör",
];

/**
 * Gender'a göre rastgele bir isim + title döndürür.
 * @param {string} gender "female" → kadın havuzu; diğer her şey → erkek havuzu.
 * @returns {{name: string, role: string}}
 */
export function randomAvatarIdentity(gender) {
  const pool = gender === "female" ? FEMALE_NAMES : MALE_NAMES;
  return {
    name: pool[Math.floor(Math.random() * pool.length)],
    role: ROLE_TITLES[Math.floor(Math.random() * ROLE_TITLES.length)],
  };
}
